// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Vuex from 'vuex';
import store from './store';
// import ElementUI from 'element-ui';
import 'lib-flexible';
// import utils from './utils/utils';
// import $ from 'jquery';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/index.scss';
import MsgBox from '@/components/messageBox/messageBox.js';
Vue.prototype.$MsgBox = MsgBox;
import {
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Select,
  Option,
  Button,
  ButtonGroup,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Icon,
  Row,
  Col,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Loading,
  MessageBox,
  Message
} from 'element-ui';

Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Input);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;

Vue.config.productionTip = false;
Vue.use(Vuex);

import smrLoading from '@/components/loading/loading.js';
smrLoading.init({ isShow: false });
Vue.prototype.$smrLoading = smrLoading;

import axios from '@/utils/request';
Vue.prototype.axios = axios;

Vue.prototype.dataCenterUrl = 'http://api.smile1001.com/data_center';

    window.onresize = function () {
        var windowHeight = document.documentElement.scrollTop==0? document.body.clientHeight : document.documentElement.clientHeight;//获取窗口的可见高度,不是整个文档的高度
        var screenHeight = window.screen.availHeight;//获取浏览器的屏幕的可用高度
        //console.log(windowHeight+','+window.screen.availHeight);
        var botBar = document.getElementById("bottom-bar");
        var searchBotBar = document.getElementById("search-bottom-bar");
        var u = navigator.userAgent;

        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
            if (windowHeight <= screenHeight / 1.5) {
              if( botBar ){
                botBar.classList.remove("fixed");
              }else if (searchBotBar) {
                searchBotBar.classList.remove("fixed");
              }
            } else {
              if( botBar ){
                botBar.classList.add("fixed");
              }else if (searchBotBar) {
                searchBotBar.classList.add("fixed");
              }
            }
        }
    }
        //alert($(window).height());
        //alert(window.screen.availHeight);

//登陆状态码
  //window.logStatus = 2000; => 于App.vue里设置
  //window.storage = window.localStorage;



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js